import { createContext, useContext, useState } from "react";

const QuizContext = createContext(null);

export const useQuiz = () => {
  const ctx = useContext(QuizContext);
  if (!ctx) throw new Error("useQuiz must be used inside QuizProvider");
  return ctx;
};

export const QuizProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [ctaOrigin, setCtaOrigin] = useState("unknown");
  const [initialArea, setInitialArea] = useState(null);

  const openQuiz = (origin = "unknown", area = null) => {
    setCtaOrigin(origin);
    setInitialArea(area);
    setIsOpen(true);
  };

  const closeQuiz = () => {
    setIsOpen(false);
    setInitialArea(null);
  };

  return (
    <QuizContext.Provider value={{ isOpen, openQuiz, closeQuiz, ctaOrigin, initialArea }}>
      {children}
    </QuizContext.Provider>
  );
};
